import AppState from '../AppState';
/**
 * Get Plan Features Taxonomy Terms from plan node.
 *
 * @param {PlanData} planData - The plan data returned from Drupal node endpoint.
 * @param {HTMLElement} modal - The modal element where the plan features will
 *                              be displayed.
 */
const getNodePlanFeatures = (planData, modal) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { baseUrl } = settings;
    const planFeatures = planData.data[0].relationships.field_plan_features.data;
    const termUrl = `${baseUrl}/jsonapi/taxonomy_term/plan_features/`;
    const fetchFeatures = planFeatures.map(feature => {
        return fetch(termUrl + feature.id + '?fields[taxonomy_term--plan_features]=name')
            .then(response => {
            if (!response.ok) {
                throw new Error('Couldn\'t get the taxonomy term');
            }
            else {
                return response.json();
            }
        })
            .then(data => {
            return data['data']['attributes']['name'];
        });
    });
    Promise.all(fetchFeatures)
        .then(featuresList => {
        featuresList.slice(1).forEach(item => {
            let newItem = document.createElement('li');
            newItem.classList.add('active');
            newItem.innerText = item;
            modal.querySelector('#featured-list').appendChild(newItem);
        });
    })
        .catch(error => {
        console.error('Error fetching data:', error);
    });
};
export default getNodePlanFeatures;
